// Payroll API calls. Paths match backend/app/api/v1/endpoints/payroll_endpoints.py.
import { http } from '../api';

const { get, post, put, del } = http;

export const overview = () => get('/payroll/overview');
export const calendar = period => get(`/payroll/calendar${period ? `?period=${period}` : ''}`);
export const saveCalendar = body => put('/payroll/calendar', body);

export const setup = () => get('/payroll/setup');
export const saveRules = body => put('/payroll/setup/rules', body);
export const saveBands = rows => put('/payroll/setup/bands', rows);
export const saveComponents = rows => put('/payroll/setup/components', rows);
export const saveProfiles = rows => put('/payroll/setup/profiles', rows);
export const saveTiers = rows => put('/payroll/setup/ot-tiers', rows);

export const projects = () => get('/payroll/projects');
export const saveProject = (siteId, body) => put(`/payroll/projects/${siteId}`, body);
export const savePayer = (id, body) => (id ? put(`/payroll/payers/${id}`, body) : post('/payroll/payers', body));
export const deletePayer = id => del(`/payroll/payers/${id}`);

export const grades = () => get('/payroll/grades');
export const saveGrade = (id, body) => (id ? put(`/payroll/grades/${id}`, body) : post('/payroll/grades', body));
export const deleteGrade = id => del(`/payroll/grades/${id}`);
export const saveSteps = rows => put('/payroll/grades/steps/all', rows);

export const benefits = () => get('/payroll/benefits');
export const saveBenefit = (id, body) => (id ? put(`/payroll/benefits/${id}`, body) : post('/payroll/benefits', body));
export const deleteBenefit = id => del(`/payroll/benefits/${id}`);
export const enrolment = () => get('/payroll/enrolment');
export const saveEnrolment = rows => put('/payroll/enrolment', rows);

export const employees = () => get('/payroll/employees');
export const saveEmployee = (id, body) => put(`/payroll/employees/${id}`, body);

export const holidays = year => get(`/payroll/holidays${year ? `?year=${year}` : ''}`);
export const saveHoliday = (id, body) => (id ? put(`/payroll/holidays/${id}`, body) : post('/payroll/holidays', body));
export const deleteHoliday = id => del(`/payroll/holidays/${id}`);

// Monthly Inputs (phase 5)
const qp = (o) => { const q = new URLSearchParams(Object.entries(o).filter(([, v]) => v)); const s = q.toString(); return s ? `?${s}` : ''; };
export const entryTypes = () => get('/payroll/entry-types');
export const saveEntryType = (id, body) => (id ? put(`/payroll/entry-types/${id}`, body) : post('/payroll/entry-types', body));
export const deleteEntryType = id => del(`/payroll/entry-types/${id}`);
export const sheet = (period, name) => get(`/payroll/sheets${qp({ period, sheet: name })}`);
export const saveSheet = (period, name, rows) => put(`/payroll/sheets${qp({ period, sheet: name })}`, { rows });
export const sheetAction = (id, action, note) => post(`/payroll/sheets/${id}/action`, { action, note });
export const loans = period => get(`/payroll/loans${qp({ period })}`);
export const loanApproval = id => get(`/payroll/loans/${id}`);
export const saveLoan = (id, body) => (id ? put(`/payroll/loans/${id}`, body) : post('/payroll/loans', body));
export const loanAction = (id, body) => post(`/payroll/loans/${id}/action`, body);
export const savings = period => get(`/payroll/savings${qp({ period })}`);
export const planApproval = id => get(`/payroll/savings/${id}`);
export const savePlan = (id, body) => (id ? put(`/payroll/savings/${id}`, body) : post('/payroll/savings', body));
export const planAction = (id, body) => post(`/payroll/savings/${id}/action`, body);
export const inputsRegister = period => get(`/payroll/inputs-register${qp({ period })}`);

// the payroll engine (Stephanet's /pay15/meta and /pay15/data)
export const meta = () => get('/payroll/meta');
export const monthData = period => get(`/payroll/data${period ? `?period=${period}` : ''}`);
export const setupOverview = () => get('/payroll/setup/overview');
export const dateControl = period => get(`/payroll/date-control${period ? `?period=${period}` : ''}`);
export const saveDateControl = body => put('/payroll/date-control', body);
export const setupSheet = () => get('/payroll/setup/sheet');
export const saveSetupSheet = body => put('/payroll/setup/sheet', body);
export const saveSite = (id, body) => (id ? put(`/payroll/sites/${id}`, body) : post('/payroll/sites', body));
export const deleteSite = id => del(`/payroll/sites/${id}`);
export const gradesSheet = () => get('/payroll/grades-sheet');
export const saveGradeSheet = (id, body) => (id ? put(`/payroll/grades-sheet/${id}`, body) : post('/payroll/grades-sheet', body));
export const saveStep = (id, body) => (id ? put(`/payroll/grade-steps/${id}`, body) : post('/payroll/grade-steps', body));
export const applyStep = id => post('/payroll/grade-steps/apply', { id });
export const deleteStep = id => del(`/payroll/grade-steps/${id}`);
export const saveBenefitSheet = (id, body) => (id ? put(`/payroll/benefits-sheet/${id}`, body) : post('/payroll/benefits-sheet', body));
export const enrolmentChoices = () => get('/payroll/enrolment-choices');
export const saveEnrolmentChoices = changes => put('/payroll/enrolment-choices', { changes });
export const employeesSheet = () => get('/payroll/employees-sheet');
export const saveEmployeeSheet = (id, body) => (id ? put(`/payroll/employees-sheet/${id}`, body) : post('/payroll/employees-sheet', body));

// Payroll Runs & Approval (phase 6)
export const runs = period => get(`/payroll/runs${qp({ period })}`);
export const calculateRun = period => post(`/payroll/runs/calculate${qp({ period })}`, {});
export const runAction = (id, body) => post(`/payroll/runs/${id}/action`, body);
export const runLines = id => get(`/payroll/runs/${id}/lines`);
export const runRegister = runId => get(`/payroll/run-lines${qp({ run_id: runId })}`);
export const payslip = lineId => get(`/payroll/payslips/${lineId}`);
export const remittances = () => get('/payroll/remittances');
export const remit = (id, body) => put(`/payroll/remittances/${id}`, body);

// Compensation and Pay Structure
export const payStructure = () => get('/payroll/structure');
export const saveComponent = (id, body) => (id ? put(`/payroll/components/${id}`, body) : post('/payroll/components', body));
export const deleteComponent = id => del(`/payroll/components/${id}`);
export const salaryChanges = () => get('/payroll/salary-changes');
export const saveSalaryChange = (id, body) => (id ? put(`/payroll/salary-changes/${id}`, body) : post('/payroll/salary-changes', body));
export const salaryChangeApproval = id => get(`/payroll/salary-changes/${id}/approval`);
export const salaryChangeAction = (id, body) => post(`/payroll/salary-changes/${id}/action`, body);
export const payItems = kind => get(`/payroll/pay-items/${kind}`);
export const savePayItem = (kind, id, body) => (id ? put(`/payroll/pay-items/${kind}/${id}`, body) : post(`/payroll/pay-items/${kind}`, body));
export const payItemApproval = id => get(`/payroll/pay-item/${id}/approval`);
export const payItemAction = (id, body) => post(`/payroll/pay-item/${id}/action`, body);
export const compBudgets = year => get(`/payroll/comp-budgets${qp({ year })}`);
export const saveCompBudget = (id, body) => (id ? put(`/payroll/comp-budgets/${id}`, body) : post('/payroll/comp-budgets', body));
export const deleteCompBudget = id => del(`/payroll/comp-budgets/${id}`);
export const benefitPolicies = () => get('/payroll/benefit-policies');

// Grade Policy Setup
export const gradeSetup = () => get('/payroll/grade-setup');
export const savePolicy = (kind, id, body) => (id ? put(`/payroll/policy/${kind}/${id}`, body) : post(`/payroll/policy/${kind}`, body));
export const deletePolicy = (kind, id) => del(`/payroll/policy/${kind}/${id}`);

// Deductions & Statutory
export const payeCalculator = body => post('/payroll/paye-calculator', body);
export const pensionTracking = ({ year, run_id } = {}) => get(`/payroll/pension-tracking${qp({ year, run_id })}`);
export const statutorySchedule = ({ status, period } = {}) => get(`/payroll/statutory-schedule${qp({ status, period })}`);

// Payslips & Payments
export const payments = view => get(`/payroll/payments/${view}`);
export const savePayment = (id, body) => (id ? put(`/payroll/payments/${id}`, body) : post('/payroll/payments', body));
export const paymentApproval = id => get(`/payroll/payment/${id}/approval`);
export const paymentBankSchedule = id => get(`/payroll/payment/${id}/bank-schedule`);
export const paymentAction = (id, body) => post(`/payroll/payment/${id}/action`, body);
export const remittancePayment = id => post(`/payroll/remittances/${id}/payment`, {});
